var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMony(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 31,
    viewBox: "0 0 36 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6 (2) 1",
    clipPath: "url(#clip0_1122_22622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6 (2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 60303",
    d: "M30.894 11.7157V19.8744L35.9927 17.9177L28.9186 -0.00390625L0 11.7157",
    fill: "#6F9935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 60304",
    d: "M32.3652 19.3107V10.2324H3.65636L1.47119 11.1138V11.7088H30.8982V19.869L32.3652 19.3107Z",
    fill: "#658B30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 60305",
    d: "M0 11.7148H30.894V30.9997H0V11.7148Z",
    fill: "#79A73A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 60306",
    d: "M2.94287 18.1768C3.76215 17.9296 4.50765 17.481 5.11235 16.8712C5.71704 16.2615 6.16196 15.5097 6.4071 14.6836H24.4872C24.7324 15.5097 25.1773 16.2615 25.782 16.8712C26.3867 17.481 27.1322 17.9296 27.9515 18.1768V24.5405C27.1322 24.7877 26.3867 25.2363 25.782 25.8461C25.1773 26.4558 24.7324 27.2076 24.4872 28.0337H6.4071C6.16175 27.2079 5.71674 26.4564 5.11206 25.8469C4.50738 25.2374 3.76198 24.789 2.94287 24.542V18.1768Z",
    fill: "#AAC16B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1163",
    d: "M15.4479 25.0668C17.4794 25.0668 19.1263 23.4062 19.1263 21.3576C19.1263 19.3091 17.4794 17.6484 15.4479 17.6484C13.4164 17.6484 11.7695 19.3091 11.7695 21.3576C11.7695 23.4062 13.4164 25.0668 15.4479 25.0668Z",
    fill: "#79A73A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 60307",
    d: "M30.3796 11.7161L28.6314 7.19161L28.5513 6.99182C27.6997 7.06805 26.8426 6.9297 26.0571 6.58918C25.2717 6.24867 24.5824 5.71667 24.0513 5.04102L23.8547 5.12181L8.09082 11.7161H30.3796Z",
    fill: "#AAC16B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 60308",
    d: "M11.6381 10.2324L8.09082 11.7161H30.3796L29.8085 10.2324H11.6381Z",
    fill: "#89B140"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 73329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1164",
    d: "M7.3553 22.1009C7.76161 22.1009 8.09098 21.7687 8.09098 21.359C8.09098 20.9493 7.76161 20.6172 7.3553 20.6172C6.949 20.6172 6.61963 20.9493 6.61963 21.359C6.61963 21.7687 6.949 22.1009 7.3553 22.1009Z",
    fill: "#79A73A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1165",
    d: "M23.5374 22.1009C23.9437 22.1009 24.2731 21.7687 24.2731 21.359C24.2731 20.9493 23.9437 20.6172 23.5374 20.6172C23.1311 20.6172 22.8018 20.9493 22.8018 21.359C22.8018 21.7687 23.1311 22.1009 23.5374 22.1009Z",
    fill: "#79A73A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1122_22622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 31,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMony);
export default __webpack_public_path__ + "static/media/mony.38b3c0ffad4aaae82853baba98ac0b53.svg";
export { ForwardRef as ReactComponent };